/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {HorribleHeroesGameModuleConfig} from "./HorribleHeroesGameModuleConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/GameModuleConfig";
import {GameRoundManager} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";
import {TimelineReelsController} from "@nolimitcity/slot-game/bin/timelinegameround/reels/TimelineReelsController";
import {HorribleHeroesEvents} from "./events/HorribleHeroesEvents";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {HHWinFieldController} from "./gameround/HHWinFieldController";

export class HorribleHeroes extends SlotGame {
    public static timelineReelsController: TimelineReelsController;
    private static gameRoundManager: GameRoundManager;

    constructor() {
        super(HorribleHeroesGameModuleConfig.instance);
    }

    start(): Promise<NolimitPlugin> {
        EventHandler.dispatchEvent(new GameEvent(HorribleHeroesEvents.ON_GAME_START));
        return super.start();
    }

    protected initGame(): void {
        if (GameModuleConfig.instance.GAME_ROUND_CONFIG) {
            Reels.init();
            HorribleHeroes.timelineReelsController = TimelineReelsController.instance;
            HorribleHeroes.gameRoundManager = new GameRoundManager(GameModuleConfig.instance.GAME_ROUND_CONFIG());
        } else {
            super.initGame();
        }
    }

    protected createWinFieldController(): HHWinFieldController {
        return new HHWinFieldController();
    }


    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "L5",
                    "L3",
                    "M2",
                    "L5",
                    "L4",
                    "L1"
                ],
                [
                    "L4",
                    "L4",
                    "L2",
                    "M4",
                    "L5",
                    "L4"
                ],
                [
                    "L3",
                    "L3",
                    "L1",
                    "M3",
                    "M5",
                    "L3"
                ],
                [
                    "L3",
                    "L2",
                    "L1",
                    "M1",
                    "M4",
                    "M3"
                ],
                [
                    "M3",
                    "L1",
                    "S",
                    "L2",
                    "L2",
                    "M2"
                ]
            ],
            "evaluatedArea": [
                [
                    "L3",
                    "M2",
                    "L5",
                    "L4"
                ],
                [
                    "L4",
                    "L2",
                    "M4",
                    "L5"
                ],
                [
                    "L3",
                    "L1",
                    "M3",
                    "M5"
                ],
                [
                    "L2",
                    "L1",
                    "M1",
                    "M4"
                ],
                [
                    "L1",
                    "S",
                    "L2",
                    "L2"
                ]
            ],
            "betWayWins": [],
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "XWaysInfectiousTriggered": false,
            "XWaysExpand": [
                false,
                false,
                false,
                false,
                false
            ],
            "XWaysInfectious": [
                false,
                false,
                false,
                false,
                false
            ],
            "highlightPotentialWinSymbol": [
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "xWaySymbolMayGiveWin": false,
            "expandedSymbol": "L5",
            "scatterCount": 1,
            "gameAreaSizeAfter": [
                4,
                4,
                4,
                4,
                4
            ],
            "gameAreaSizeXwaysExpand": [
                4,
                4,
                4,
                4,
                4
            ],
            "totalNumberOfWays": 1024,
            "numberOfWaysWon": 0,
            "gameSizeEnteringFreespin": [
                4,
                4,
                4,
                4,
                4
            ],
            "freespinTriggeredThisSpin": false,
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                1
            ],
            "bonusPositions": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "addedNumberOfFreespinsThisSpin": 0,
            "nearWinBigWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "superFSTriggered": false,
            "playerFSSelection": -1,
            "featureBuyTimesBetValue": [
                {
                    "name": "FREESPIN_3_SCATTERS",
                    "type": "FREESPIN",
                    "price": 75
                },
                {
                    "name": "FREESPIN_4_SCATTERS",
                    "type": "FREESPIN",
                    "price": 140
                },
                {
                    "name": "FREESPIN_5_SCATTERS",
                    "type": "FREESPIN",
                    "price": 555
                }
            ],
            "wasFeatureBuy": false,
            "featureBet": false,
            "numberOfSpinsFreespin": 0,
            "lockedWildNextSpin": [
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "symbolSizes": [
                [
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0
                ]
            ],
            "superFSActivated": false,
            "XSymbolPositions": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "numberOfExpandSymbolOnReel": [
                0,
                0,
                0,
                0,
                0
            ],
            "reelExpandSize": [
                0,
                0,
                0,
                0,
                0
            ],
            "wildMultipliers": [
                [
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0
                ]
            ],
            "brokeTheBank": false,
            "freespinSpinChoices": [
                0,
                0
            ],
            "randomWildFS": [
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "playerInteraction": {},
            "fsCollectedScatters": 0
        };
    }

}